import * as React from 'react';

import type { AddressVM } from 'ab-viewModels/workRequest/workRequestPreviewDetails.viewModel';

import { SegmentLabel } from '@acceligentllc/storybook';

import NonEditableMap from 'af-components/Maps/NonEditableMap';

import { previewSectionClass, previewSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

interface OwnProps {
	workLocation: Nullable<AddressVM>;
}

type Props = OwnProps;

const _formatStreet = (address: AddressVM) => {
	const { streetNumber, street, city, state, neighborhood, country } = address;
	const streetArray: string[] = [];
	if (street) {
		streetArray.push(street);
	}
	if (neighborhood) {
		streetArray.push(neighborhood);
	}
	if (city) {
		streetArray.push(city);
	}
	if (state) {
		streetArray.push(state);
	}
	if (country) {
		streetArray.push(country);
	}
	return `${streetNumber ? streetNumber : ''} ${streetArray.join(', ')}`;
};

const WorkLocationSection: React.FC<Props> = (props) => {
	const { workLocation } = props;

	const location = React.useMemo(() => {

		return workLocation?.latitude && workLocation?.longitude
			? {
				lat: workLocation.latitude,
				lng: workLocation.longitude,
			}
			: null;
	}, [workLocation?.latitude, workLocation?.longitude]);

	if (!workLocation) {
		return null;
	}

	return (
		<div className={previewSectionClass}>
			<SegmentLabel
				label="Work Location"
				tooltip={`
					Location where work is being done — used to determine the time zone for payroll reports.
					If a Work Order has no work location set, the time zone is taken from this address;
					otherwise, the company's time zone is used
				`}
			/>
			<div className={previewSectionClassRow}>
				Street Address
			</div>
			<div>
				<strong>{_formatStreet(workLocation)}</strong>
			</div>
			{workLocation.notes &&
				<div>
					{workLocation.notes}
				</div>
			}
			{location &&
				<NonEditableMap
					additionalContainerClassName={styles['work-request-preview__address-map-container']}
					location={location}
				/>
			}
		</div>
	);
};

export default React.memo(WorkLocationSection);
